import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [packageType, setPackageType] = useState('basic');
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is already logged in
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      const userData = JSON.parse(storedUser);
      setUser(userData);
      setPackageType(userData.package_type || 'basic');
      setIsAdmin(userData.is_admin || false);
    }
    setLoading(false);
  }, []);

  const login = (userData) => {
    setUser(userData);
    setPackageType(userData.package_type || 'basic');
    setIsAdmin(userData.is_admin || false);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const logout = () => {
    setUser(null);
    setPackageType('basic');
    setIsAdmin(false);
    localStorage.removeItem('user');
    // Add any additional cleanup or API calls for logout
  };

  const isPremium = packageType === 'advance';

  return (
    <AuthContext.Provider value={{ 
      user, 
      packageType, 
      isAdmin,
      isPremium, 
      login, 
      logout, 
      loading 
    }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
